module.exports = __webpack_public_path__ + "static/media/download.48a76074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/download.jpg
// module id = 1630
// module chunks = 0